/* eslint-disable */
import {
  Avatar,
  ChatContainer,
  Conversation,
  ConversationHeader,
  ConversationList,
  MainContainer,
  Message,
  MessageInput,
  MessageList,
  Sidebar,
} from "@chatscope/chat-ui-kit-react";
import React, { useCallback, useEffect, useState } from 'react';
import ApiService from '../ApiService.js';
import DownloadApk from '../components/download_apk.js';
import Sidebars from '../components/sidebar/sidebar.jsx';
import { CLIENT_CURRENT, GET_ADMIN_MSG, GET_USERS_MSG, MESSAGE_SEND_MSG } from '../constants.js';
import { useEmulatorStore } from '../stores/emulator/store.tsx';
import { generateUUID } from "../components/location/map-components/CreateTrip/autocomplete/utils.js"; 

const Chat = () => {

  // const emulators = useEmulatorStore((state) => state.emulators)
  const fetchUsers = useEmulatorStore((state) => state.fetchUsers)
  const users = useEmulatorStore((state) => state.users)

  const [user, setUser] = useState();
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  // const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchUsers()
  }, [])

  const token = localStorage.getItem('token')

  console.log('selectedUser', selectedUser)

  console.log('user', user)

  console.log('messages', messages)

  const fetchClientData = async () => {
    try {
      const response = await fetch(CLIENT_CURRENT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok || response.status !== 200) {
        return { success: false, error: 'Invalid credentials' }
      } else {
        const responseData = await response.text()
        const deserializedData = JSON.parse(responseData)
        setUser(deserializedData)
        return { success: true, error: null }
      }
    } catch (error) {
      console.error('Data Error: ' + error)
    }
  }

  useEffect(() => {
    fetchClientData()
  }, [])

  const handleSendMessage = async (text) => {
    if (!text.trim()) return;

    if(!user?.telephone) {
      alert('LoggedIn user does not have a telephone no.')
      return;
    }

    let payload;

    if (user?.authorities[0]?.authority === 'ROLE_ADMIN') {
      if (!selectedUser) return;

      if(!selectedUser?.telephone) {
        alert('Selected user does not have a telephone no.')
        return;
      }
      payload = {
        message: text,
        userId: selectedUser?.id,
      };
    } else {  // For ROLE_USER
      payload = {
        message: text,
      };
    }

    const { success, error } = await ApiService.makeApiCall(
      MESSAGE_SEND_MSG,
      'POST',
      payload,
      token,
      null
    );

    if (success) {
      const newMsg = {
        id: generateUUID(),
        text,
        direction: 'outgoing',
        date: new Date()
      }
      console.log('newMsg', newMsg)
      setMessages((prev) => [...prev, newMsg])
    } else {
      console.error('Message sending failed:', error);
    }
  };

  useEffect(() => {
    const getMsg = async () => {
      const token = localStorage.getItem('token')
      const role = user?.authorities[0]?.authority;
      
      if (!user?.telephone || !token) return;

      try {
        let result = [];

        if(role === 'ROLE_ADMIN') {
          if (!selectedUser?.telephone) return;

          const res = await fetch(GET_USERS_MSG, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          })
          const responseData = await res.text()
          const allMessages = JSON.parse(responseData)

          result = allMessages.filter(msg =>
            (msg.from?.endpoint === user.telephone && msg.to === selectedUser.telephone) ||
            (msg.to === user.telephone && msg.from?.endpoint === selectedUser.telephone)
          );
        } else {  // For ROLE_USER
            const res = await fetch(GET_ADMIN_MSG(user.id), {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
              }
            })
            const responseData = await res.text()
            const allMessages = JSON.parse(responseData)

            result = allMessages.filter(msg =>
              (msg.from?.endpoint === user.telephone) || (msg.to === user.telephone)
            );
          }
          const formattedMessages = result
          .map(msg => {
            const isSent = msg.direction === 'OUTBOUND_API' && msg.from?.endpoint === user.telephone;
            const isReceived = msg.direction === 'INBOUND' && msg.to === user.telephone;

            return {
              id: generateUUID(),
              text: msg.body,
              direction: isSent ? 'outgoing' : isReceived ? 'incoming' : 'unknown',
              date: new Date(msg.dateSent)
            };
          })
          .filter(m => m.direction !== 'unknown')
          .sort((a, b) => a.date - b.date);

          setMessages(formattedMessages);
      } catch (error) {
        console.error('getMsg Error: ' + error)
      }
    }
    getMsg()
  }, [user?.id, user?.telephone, selectedUser?.telephone])

  const handleBackClick = () => {};

  const handleConversationClick = useCallback( (driver) => {
    setSelectedUser(driver);
  }, [] );

  // if (loading) {
  //   return <div>Loading</div>
  // }

  return (
    <>
      <section className="dashboard align-items-center">
        <div className="container-fluid d-flex ps-0">
          <div>
            <Sidebars />
          </div>
          <div className="row w-100">
            <DownloadApk />
            <div style={{height: "550px", position: "relative"}}>
              <MainContainer responsive>
              <Sidebar
                position="left"
              >
                <ConversationList>
                  <ConversationHeader>
                    <ConversationHeader/>
                      <Avatar src="https://chatscope.io/storybook/react/assets/joe-v8Vy3KOS.svg" name="Admin" status="available" />
                    <ConversationHeader.Content userName={`${user?.firstName} ${user?.lastName}`}/>
                  </ConversationHeader>
                  {
                    user?.authorities[0]?.authority === 'ROLE_ADMIN' ? (
                      users.length > 0 ? (
                        users.map((driver, index) => (
                          <Conversation key={index} onClick={() => handleConversationClick(driver)}
                            style={selectedUser === driver ? { backgroundColor: '#F0F8FF' } : {}}>
                              <Avatar src="" className='d-flex justify-content-center align-items-center' style={{ backgroundColor: '#dae3e5' }}>
                                {`${driver?.firstName?.charAt(0) ?? ''}${driver?.lastName?.charAt(0) ?? ''}`}
                              </Avatar>
                              <Conversation.Content className='d-flex justify-content-center'
                                name={`${driver?.firstName} ${driver?.lastName}`} />
                          </Conversation>
                        ))
                      ) : (
                        <div>No user found</div>
                      )
                    ) : (
                      <Conversation onClick={() => handleConversationClick({ firstName: "Admin", lastName: "", telephone:"+13308628874" })}>
                        <Avatar src="" className='d-flex justify-content-center align-items-center' style={{ backgroundColor: '#dae3e5' }}>A</Avatar>
                        <Conversation.Content className='d-flex justify-content-center' name="Admin" />
                      </Conversation>
                    )
                  }
                </ConversationList>
              </Sidebar>
                {
                  selectedUser ? (
                    <ChatContainer>
                      <ConversationHeader>
                        <ConversationHeader.Back onClick={handleBackClick}/>
                        <Avatar src="" className='d-flex justify-content-center align-items-center' style={{ backgroundColor: '#dae3e5' }}>
                          {`${selectedUser?.firstName?.charAt(0) ?? ''}${selectedUser?.lastName?.charAt(0) ?? ''}`}
                        </Avatar>
                        <ConversationHeader.Content userName={`${selectedUser?.firstName} ${selectedUser?.lastName}`}/>
                      </ConversationHeader>
                      <MessageList>
                        {
                          messages && messages.length !== 0 && selectedUser?.telephone ? (
                            messages.map(msg => (
                              <Message
                                key={msg.id}
                                model={{
                                  message: msg.text,
                                  direction: msg.direction,
                                  position: 'single'
                                }}
                              />
                            ))
                          )  : (
                          <div className='d-flex justify-content-center align-items-center h-100'>No messages</div>
                          )
                        }
                      </MessageList>
                      <MessageInput
                        placeholder="Type..."
                        attachButton={false}
                        onSend={(innerText) => handleSendMessage(innerText)}
                      />
                    </ChatContainer>
                  ) : (
                    <ChatContainer>
                      <ConversationHeader style={{ paddingBottom: "1.8rem", paddingTop: "2rem" }}>
                        <ConversationHeader.Back onClick={handleBackClick}/>
                      </ConversationHeader>
                      <MessageList>
                        <MessageList.Content style={ { display: "flex", "flexDirection": "column", "justifyContent": "center", height: "100%", textAlign: "center", fontSize: "1.2em" }} >
                          Select a user to start a conversation
                        </MessageList.Content>
                      </MessageList>
                    </ChatContainer>                       
                  )
                }
              </MainContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Chat